import BaseResource from './index'
import DayTypeResource from './dayType'

export default class RuleResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/rules'

    static related() {
        return {
            day_type_id: DayTypeResource,
        }
    }
}
